// src/components/CountdownTimer.jsx
import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import { t } from "i18next";

dayjs.extend(duration);

const ZERO = { days: 0, hours: 0, mins: 0, secs: 0, completed: false };

function CountdownTimer({ pujaDate, pujaTime, format = "M/D/YYYY HH:mm:ss" }) {
    // --- parse the combined date + time string into a dayjs object ---
    const parseTarget = () => {
        if (!pujaDate || !pujaTime) return null;
        const main = dayjs(`${pujaDate.split(" ")[0]} ${pujaTime}`, format);

        if (main.isValid()) return main;

        // fallback if backend sends D/M/YYYY
        const alt = dayjs(`${pujaDate.split(" ")[0]} ${pujaTime}`, "D/M/YYYY HH:mm:ss");
        if (alt.isValid()) return alt;

        console.warn("CountdownTimer: invalid date/time:", pujaDate, pujaTime);
        return null;
    };

    const compute = (target) => {
        const diff = target.diff(dayjs());
        if (diff <= 0) return { ...ZERO, completed: true };

        const total = Math.floor(diff / 1000);
        const days = Math.floor(total / 86400);
        const hours = Math.floor((total % 86400) / 3600);
        const mins = Math.floor((total % 3600) / 60);
        const secs = total % 60;
        return { days, hours, mins, secs, completed: false };
    };

    const [timeLeft, setTimeLeft] = useState(ZERO);

    useEffect(() => {
        const target = parseTarget();
        if (!target) {
            setTimeLeft(ZERO);
            return;
        }

        setTimeLeft(compute(target)); // run immediately
        const id = setInterval(() => setTimeLeft(compute(target)), 1000);
        return () => clearInterval(id);
    }, [pujaDate, pujaTime, format]);

    const pad = (n) => String(n).padStart(2, "0");

    if (timeLeft.completed) {
        return <span className="text-danger fw-bold">{t("Started / Completed")}</span>;
    }

    return (
        <div className="d-flex main-counterstyle">
            {[t("days"), t("hours"), t("mins"), t("secs")].map((unit, i) => (
                <div key={unit} className={`text-center ${i < 3 ? "me-3" : ""}`}>
                    <h3 className="mb-0 fw-bold main-counter" style={{ fontSize: "20px" }}>{pad(timeLeft[unit])}</h3>
                    <p className="small time-style">
                        {t(unit.charAt(0).toUpperCase() + unit.slice(1, unit.length))}
                    </p>
                </div>
            ))}
        </div>
    );
}

export default CountdownTimer;
